<template>
  <div
    class="w-full flex flex-col flex-grow min-h-full max-w-96 md:w-1/2 lg:w-1/3 rounded-3xl px-6 py-10 bg-primary-200"
    data-aos="fade-left"
  >
    <div class="h-full flex flex-col justify-start text-black">
      <div>
        <h3
          class="mb-4 text-3xl font-bold font-heading min-h-[1lh] md:min-h-[2lh] lg:min-h-[2lh]"
        >
          {{ product.name }}
        </h3>
        <p
          class="my-3 text-base min-h-[1lh] md:min-h-[4lh] lg:min-h-[2lh] text-dark"
        >
          {{ product.description }}
        </p>

        <p
          class="mt-3 mb-8 text-xl text-left text-primary-color font-bold min-h-[1lh] md:min-h-[3lh] lg:min-h-[2lh]"
        >
          {{ product.details?.title || "" }}
        </p>
        <div class="flex flex-col text-left md:min-h-[310px] lg:min-h-[260px]">
          <ul class="text-dark">
            <FeatureProduct
              v-for="(feature, index) in features"
              :key="index"
              :feature="feature"
            />
          </ul>
        </div>
      </div>
      <div>
        <p
          class="mt-3 mb-8 text-sm text-left text-black font-bold min-h-[2lh] md:min-h-[4lh] lg:min-h-[3lh]"
          v-if="product.details"
        >
          Best for:
          <span class="font-normal">
            {{ product.details?.target || "" }}
          </span>
        </p>
        <div
          class="block px-6 py-5 mb-4 text-base font-semibold leading-none text-center rounded-lg sm:mb-0"
          :class="
            buttonText == 'Talk to us'
              ? 'hover:bg-primary-color hover:text-white btn-no-color w-full '
              : 'btn-primary w-full'
          "
          v-if="
            currPlan && product.private_name.toLowerCase() == $products.FACE
          "
        >
          {{ buttonText }}
        </div>
        <div
        :class="
            buttonText == 'Talk to us'
              ? 'hover:bg-primary-color hover:text-white btn-no-color w-full '
              : 'btn-primary w-full'
          "
          :data-product="paddleId"
          @click="planAction()"
          v-else
          :id="'plan-' + keyRef"
        >
          {{ buttonText }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeatureProduct from "../Pricing/featuresProduct.vue";

export default {
  components: { FeatureProduct },
  props: [
    "product",
    "currPlan",
    "needBillingAddressForm",
    "keyRef",
    "paddleId",
    "errors",
  ],

  data() {
    return {
      title: "",
      subtitle: "",
      form: {
        firstName: null,
        lastName: null,
        company: null,
        email: null,
      },
    };
  },
  computed: {
    features: function () {
      return this.product.features.split(",").map(function (item) {
        return item.trim();
      });
    },

    buttonText: function () {
      if (this.product.private_name.toLowerCase() == this.$products.FACE) {
        if (this.currPlan /*  && this.currPlan.plan_id == this.paddleId */) {
          return "Subscribed";
        }
        return "Try for free";
      } else {
        return "Talk to us";
      }
    },
  },
  methods: {
    planAction() {
      if (this.product.private_name.toLowerCase() == this.$products.FACE) {
        if (this.$page.props.auth.user == null) {
          this.$inertia.visit(this.$route("login"));
          return;
        }
        if (this.needBillingAddressForm) {
          this.$emit("showBillingAddressPopup", this.keyRef);
          return;
        }
        if (this.currPlan) {
          return;
        }
        this.openPaddlePopup();
      } else {
        this.$emit("showForm");
      }
    },

    openPaddlePopup() {
      let self = this;
      if (this.paddleId != 0) {
        Paddle.Checkout.open({
          product: this.paddleId,
          email: this.$page.props.auth.user.email,
          disableLogout: true,
          successCallback: function () {
            self.$emit("setCurrentPlan", this.paddleId);
            self.$store.commit("showFlashMessage", {
              message:
                "Your transaction has been completed successfully. We have emailed you details of your order.",
            });
          },
        });
      }
    },
  },
};
</script>
